<template>
  <div style="background-color: #f4fbff">
    <Header
            :leftArrow="true"
            :leftText="''"
            @leftClick="onClickLeft"></Header>
    <div class="home home-user tel-room-in">
      <div class="tel-room_inner" >
        <div class="preview-area">
          <video
            ref="myCamera"
            class="preview-video"
            :class="{ 'preview-video-hidden': !previewReady }"
            autoplay
            webkit-playsinline
            playsinline
            muted
            id="myCamera"
            v-show="cameraOpen"
          />
          <div class="tel-room_cam cam-off preview-placeholder" v-show="!cameraOpen || !previewReady">
            <p class="cam-off_txt">{{ cameraPreviewMessage }}</p>
          </div>
        </div>
        <div class="tel-room_btn home_menu-area clear">
          <div :class="{ 'tel-room_btn-mic-on': mikeOpen }" class="home_menu-item tel-room_btn-mic" @click="mikeChange">
            <span class="home_menu-txt" v-show="mikeOpen">ON</span>
            <span class="home_menu-txt" v-show="!mikeOpen">OFF</span>
          </div>
          <div :class="{ 'tel-room_btn-video-on': cameraOpen }" class="home_menu-item tel-room_btn-video" @click="cameraChange">
            <span class="home_menu-txt" v-show="cameraOpen">ON</span>
            <span class="home_menu-txt" v-show="!cameraOpen">OFF</span>
          </div>
        </div>
        <van-button class="tel-room_start" @click="checkPermission">開始</van-button>
      </div>
    </div>
    <van-dialog v-model:show="dialogShow" title="チケット必要" show-cancel-button
      @confirm="checkPermission()">
      <div class="dialog-box">
        <div class="input-wrapper">
          <label class="input-label">チケット:</label>
          <input type="text" class="input-field" v-model="ticket">
        </div>
      </div>
    </van-dialog>
<!--    <Footer />-->
  </div>
</template>

<script>
  import Footer from "@/components/Footer.vue";
  import Header from "@/components/Header.vue";
  import {GetRoomDetail, RoomYoteiCheck} from "@/services/room.js";
  import { SaveRoomLog } from "@/services/room";
  import {Dialog, Toast} from "vant";
  import "vant/es/toast/style";

  export default {
  data() {
    return {
      roomInfo: {},
      mikeOpen: false,
      cameraOpen: false,
      id:'',
      room_id:'',
      dialogShow:false,
      ticket:null,
      yotei_id:null,
      mediaStream: null,
      openCameraTime:null,
      mediaRequestPending:false,
      previewReady:false,
      mediaRequestId:0,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.room_id = this.$route.query.room_id;
    this.ticket = this.$route.query.ticket;
    this.yotei_id = this.$route.query.yotei_id;
  },
  beforeUnmount(){
    this.stopNavigator();
  },
  methods: {
    isMediaPermissionDenied(error) {
      return ["NotAllowedError", "PermissionDeniedError", "SecurityError"].includes(error?.name);
    },
    getRoomMediaErrorMessage(error, audioEnabled, videoEnabled) {
      if (this.isMediaPermissionDenied(error)) {
        if (audioEnabled && videoEnabled) {
          return "マイクとカメラの権限が異常です。";
        }
        if (audioEnabled) {
          return "マイク権限が異常です。";
        }
        return "カメラ権限が異常です。";
      }
      if (["NotFoundError", "DevicesNotFoundError", "OverconstrainedError"].includes(error?.name)) {
        if (audioEnabled && videoEnabled) {
          return "利用できるマイクまたはカメラが見つかりません。";
        }
        if (audioEnabled) {
          return "利用できるマイクが見つかりません。";
        }
        return "利用できるカメラが見つかりません。";
      }
      return "マイクまたはカメラを起動できませんでした。";
    },
    getVideoElement() {
      return this.$refs.myCamera || document.getElementById("myCamera");
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    stopMediaStream(stream) {
      if (!stream || typeof stream.getTracks !== "function") {
        return;
      }
      stream.getTracks().forEach((track) => {
        if (track && typeof track.stop === "function") {
          track.stop();
        }
      });
    },
    resetPreviewVideo() {
      const videoElement = this.getVideoElement();
      if (!videoElement) {
        return;
      }
      try {
        videoElement.pause?.();
      } catch (error) {
        console.log(error);
      }
      videoElement.srcObject = null;
    },
    waitForPreviewFrame(videoElement, requestId) {
      if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
        return Promise.resolve(requestId === this.mediaRequestId);
      }
      return new Promise((resolve) => {
        let done = false;
        const cleanup = () => {
          videoElement.removeEventListener("loadedmetadata", check);
          videoElement.removeEventListener("loadeddata", check);
          videoElement.removeEventListener("playing", check);
        };
        const finish = (result) => {
          if (done) {
            return;
          }
          done = true;
          cleanup();
          resolve(result);
        };
        const check = () => {
          if (requestId !== this.mediaRequestId) {
            finish(false);
            return;
          }
          if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
            finish(true);
          }
        };
        videoElement.addEventListener("loadedmetadata", check);
        videoElement.addEventListener("loadeddata", check);
        videoElement.addEventListener("playing", check);
        setTimeout(() => {
          check();
          if (!done) {
            finish(false);
          }
        }, 1500);
      });
    },
    async attachPreviewStream(stream, showVideo = this.cameraOpen, requestId = this.mediaRequestId) {
      const videoElement = this.getVideoElement();
      if (!videoElement) {
        return false;
      }
      if (stream && stream.getVideoTracks().length > 0 && showVideo) {
        videoElement.srcObject = stream;
        videoElement.muted = true;
        videoElement.playsInline = true;
        if (typeof videoElement.play === "function") {
          try {
            const playResult = videoElement.play();
            if (playResult && typeof playResult.then === "function") {
              await playResult;
            }
          } catch (error) {
            console.log("beforeRoom preview play failed:", error);
            return false;
          }
        }
        return await this.waitForPreviewFrame(videoElement, requestId);
      } else {
        this.resetPreviewVideo();
      }
      return false;
    },
    applyLocalMediaState({ audioEnabled = this.mikeOpen, videoEnabled = this.cameraOpen } = {}) {
      const previousCameraOpen = this.cameraOpen;
      this.mikeOpen = audioEnabled;
      this.cameraOpen = videoEnabled;
      if (videoEnabled && !previousCameraOpen) {
        this.openCameraTime = new Date();
      } else if (!videoEnabled) {
        this.openCameraTime = null;
      }
    },
    async checkPermission(){
      if ((this.mikeOpen || this.cameraOpen) && !this.mediaStream) {
        const mediaResult = await this.syncRoomMedia({
          audioEnabled: this.mikeOpen,
          videoEnabled: this.cameraOpen,
        });
        if (!mediaResult.ok) {
          return;
        }
      }
      // 检测是否可以进入房间
      const res = await RoomYoteiCheck({
        room_id: this.room_id,yotei_id:this.yotei_id,ticket:this.ticket
      });
      if(res.data.code >=0){
        const permission = this.checkRoomPermission(res.data.data);
        if(permission !== 'can'){
          this.doErrorPermission(permission,res.data.data);
        }else{
          this.onStart();
        }
      }else{
        Toast.fail('ルームは存在しません。')
      }
    },
    doErrorPermission(permission,data){
      if(permission == 'no-room-permission'){
        // 没有房间权限
        this.dialogAlert("入室許可がありません、\nルーム管理者に連絡してほしい。");
      }else if(permission == 'no-yotei-permission'){
        // 记录预约会议Id 后续比较用
        this.yotei_id = data.yotei_list[0].yotei_id;
        // 没有会议权限 弹出ticket输入框
        this.dialogShow = true;
      }else if(permission == 'wait-yotei'){
        // 会议还没开始
        this.dialogAlert("会議["+data.yotei_list[0].yotei_name+"]は"+
            data.yotei_list[0].yotei_start_time+
            "に開始されます。しばらくお待ちください。");
      }
    },
    dialogAlert(message){
      Dialog.alert({message: message});
    },
    checkRoomPermission(data){
      if(data.yotei_list.length > 0){
        const yotei = data.yotei_list[0];
        // 如果会议进行中，必须要有会议权限
        if (yotei.meeting_status === 'in_progress') {
          // 无会议权限
          if (!yotei.yotei_permission) {
            return 'no-yotei-permission';
          }
          return 'can';
        }
        // 会议未开始时，有房间权限就可以进入
        if (data.room_permission) {
          return 'can';
        }
        // 没有房间权限，检查会议权限
        if (!yotei.yotei_permission) {
          return 'no-yotei-permission';
        }
        // 有会议权限但会议未开始，且无房间权限
        return 'wait-yotei';
      }else{
        // 无预约会议
        return data.room_permission ? 'can' : 'no-room-permission';
      }
    },
    onClickLeft() {
      history.back();
    },
    async stopNavigator() {
      this.mediaRequestId++;
      if (this.mediaStream) {
        this.stopMediaStream(this.mediaStream);
        this.mediaStream = null;
      }
      this.mediaRequestPending = false;
      this.previewReady = false;
      this.resetPreviewVideo();
    },
    async syncRoomMedia({ audioEnabled = this.mikeOpen, videoEnabled = this.cameraOpen, showError = true, retry = true } = {}) {
      if (!audioEnabled && !videoEnabled) {
        await this.stopNavigator();
        return { ok: true, error: null };
      }
      if (this.mediaRequestPending) {
        return { ok: false, error: new Error("media_request_pending") };
      }
      const requestId = ++this.mediaRequestId;
      const previousStream = this.mediaStream;
      this.mediaRequestPending = true;
      if (videoEnabled) {
        this.previewReady = false;
      }
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: audioEnabled,
          video: videoEnabled
        });
        if (requestId !== this.mediaRequestId) {
          this.stopMediaStream(stream);
          return { ok: false, error: new Error("media_request_cancelled") };
        }
        if ((videoEnabled && stream.getVideoTracks().length === 0) || (audioEnabled && stream.getAudioTracks().length === 0)) {
          this.stopMediaStream(stream);
          if (showError) {
            Toast(this.getRoomMediaErrorMessage(new Error("media_track_missing"), audioEnabled, videoEnabled));
          }
          return { ok: false, error: new Error("media_track_missing") };
        }
        if (previousStream && previousStream !== stream) {
          previousStream.getTracks().forEach((track) => {
            if (track && typeof track.stop === "function") {
              track.stop();
            }
          });
        }
        this.mediaStream = stream;
        if (videoEnabled) {
          const attached = await this.attachPreviewStream(stream, videoEnabled, requestId);
          if (!attached) {
            this.stopMediaStream(stream);
            this.mediaStream = null;
            this.previewReady = false;
            this.resetPreviewVideo();
            if (retry && requestId === this.mediaRequestId && this.cameraOpen) {
              await this.wait(300);
              if (requestId === this.mediaRequestId && this.cameraOpen) {
                this.mediaRequestPending = false;
                return await this.syncRoomMedia({
                  audioEnabled,
                  videoEnabled,
                  showError,
                  retry: false,
                });
              }
            }
            if (showError) {
              Toast(this.getRoomMediaErrorMessage(new Error("preview_play_failed"), audioEnabled, videoEnabled));
            }
            return { ok: false, error: new Error("preview_play_failed") };
          }
          this.previewReady = true;
        } else {
          this.previewReady = false;
          this.resetPreviewVideo();
        }
        return { ok: true, error: null };
      } catch (error) {
        console.error('Failed to get user media:', error);
        if (showError) {
          Toast(this.getRoomMediaErrorMessage(error, audioEnabled, videoEnabled));
        }
        if (requestId === this.mediaRequestId && videoEnabled) {
          this.previewReady = false;
          this.resetPreviewVideo();
        }
        return { ok: false, error };
      } finally {
        if (requestId === this.mediaRequestId) {
          this.mediaRequestPending = false;
        }
      }
    },
    onStart() {
      const leaveRoomTime = this.$store.state.leaveRoomTime;
      const nowDate = new Date();
      const diffHangUp = Math.floor((nowDate - leaveRoomTime) / 1000);
      if (diffHangUp < 2) {
        Toast.loading({
          message: "",
          forbidClick: true,
          duration: 2000,
        });
        setTimeout(() => {
          this.toRoom();
        }, 2000);
      } else {
        this.toRoom();
      }
    },
    async toRoom() {
      if (this.cameraOpen && this.mediaRequestPending) {
        Toast("カメラを起動しています。しばらくお待ちください。");
        return;
      }
      if (this.cameraOpen && !this.previewReady) {
        Toast("カメラを起動できませんでした。");
        return;
      }
      if(this.openCameraTime){
        const currentTime = new Date();
        const diff = Math.abs(currentTime - this.openCameraTime) ;
        if(diff <= 1500){
          // 开启过快的话 需要加一个loading
          Toast.loading({
            message: "",
            forbidClick: false,
            duration: 2000,
          });
          this.openCameraTime  = null;
          setTimeout(() => {
            this.toRoom();
          }, 2000);
          return;
        }
      }
      const room_id = this.room_id;
      try {
        const res = await GetRoomDetail(room_id);
        let roomInfo = res.data.data.detail;
        let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
        if (roomInfo && userInfo) {
          // 将摄像头状态传递给下一个页面
          const cameraState = this.cameraOpen;
          this.$router.push({
            path: "/roomConversation",
            query: {id: roomInfo.id, room_id: roomInfo.room_id, mikeOpen: this.mikeOpen,
              cameraOpen: cameraState, yotei_id: this.yotei_id, ticket: this.ticket},
          });
          if (userInfo.type === "4") {
            await SaveRoomLog({doctor_id: userInfo.login_account_id, room_id: roomInfo.room_id, type: "join",});
          }
        }
      }catch (error) {
        console.error('Failed to navigate:', error);
        if(this.cameraOpen){
          await this.syncRoomMedia({
            audioEnabled: this.mikeOpen,
            videoEnabled: this.cameraOpen,
          });
        }
      }
    },
    async mikeChange() {
      const nextMikeOpen = !this.mikeOpen;
      const mediaResult = await this.syncRoomMedia({
        audioEnabled: nextMikeOpen,
        videoEnabled: this.cameraOpen,
      });
      if (mediaResult.ok) {
        this.applyLocalMediaState({
          audioEnabled: nextMikeOpen,
          videoEnabled: this.cameraOpen,
        });
      }
    },
    async cameraChange() {
      const previousCameraOpen = this.cameraOpen;
      const nextCameraOpen = !this.cameraOpen;
      if (nextCameraOpen) {
        this.cameraOpen = true;
        this.previewReady = false;
      } else {
        this.cameraOpen = false;
        this.mediaRequestId++;
        this.mediaRequestPending = false;
        this.previewReady = false;
        this.resetPreviewVideo();
        if (!this.mikeOpen) {
          await this.stopNavigator();
          this.openCameraTime = null;
          return;
        }
        await this.syncRoomMedia({
          audioEnabled: this.mikeOpen,
          videoEnabled: false,
        });
        this.openCameraTime = null;
        return;
      }
      const mediaResult = await this.syncRoomMedia({
        audioEnabled: this.mikeOpen,
        videoEnabled: nextCameraOpen,
      });
      if (mediaResult.ok) {
        this.cameraOpen = nextCameraOpen;
        if (nextCameraOpen && !previousCameraOpen) {
          this.openCameraTime = new Date();
        } else if (!nextCameraOpen) {
          this.openCameraTime = null;
        }
      } else {
        this.cameraOpen = previousCameraOpen;
      }
    },
  },
  watch: {},
  computed: {
    cameraPreviewMessage() {
      if (this.cameraOpen && this.mediaRequestPending) {
        return "カメラを起動しています";
      }
      if (this.cameraOpen && !this.previewReady) {
        return "カメラを起動しています";
      }
      return "カメラがオフになっています";
    },
  },
};
</script>

<style scoped>
.preview-area {
  width: 100%;
  height: 300px;
  background: #201D1D;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
  transform: scaleX(-1);
  display: block;
}

.preview-video-hidden {
  visibility: hidden;
}

.preview-placeholder {
  position: absolute;
  inset: 0;
  height: 100% !important;
  border-radius: 5px;
}

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  margin :20px 30px 40px 30px;
}

.input-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.input-field {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
}

.input-field:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}

.input-field::placeholder {
  color: #999;
}
</style>
